import React, { useState } from "react";

const AddGuarantors = ({
  isAddGuarantorsOpen,
  closeAddGuarantors,
  handleSubmitGuarantors,
  refreshGuarantors,
  handleRemoveGuarantor,
  manualLoanGuarantors = [],
  guarantorRequestId,
  handleSubmitLoanApplication,
  handleGuarantorBack,
}) => {
  const [guarantorName, setGuarantorName] = useState("");
  const [guarantorPhone, setGuarantorPhone] = useState("");

  const addGuarantor = async () => {
    if (!guarantorName || !guarantorPhone) return;
    const newGuarantor = { name: guarantorName, phone: guarantorPhone };

    try {
      await handleSubmitGuarantors(newGuarantor);
      setGuarantorName("");
      setGuarantorPhone("");
      if (refreshGuarantors) await refreshGuarantors();
    } catch (error) {
      console.error("Failed to add guarantor:", error);
    }
  };

  if (!isAddGuarantorsOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      {/* Retained w-[740px] maximum bounds with responsive max-height */}
      <div className="relative bg-white shadow-md rounded-md w-full max-w-[740px] my-auto p-5 sm:p-8 md:p-10 flex flex-col max-h-[90vh] transition-all">
        {/* Close Button */}
        <button
          onClick={closeAddGuarantors}
          className="absolute top-4 right-5 text-gray-500 hover:text-black text-xl font-bold p-1 leading-none"
          aria-label="Close modal"
        >
          &times;
        </button>

        {/* Header */}
        <div className="mb-6 pr-6">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-1 break-words">
            Add Guarantors
          </h2>
          <p className="text-gray-600 text-xs sm:text-sm">
            Add Guarantors from below
          </p>
        </div>

        {/* Form Inputs Section */}
        <div className="flex flex-col gap-4 mb-6 shrink-0">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className="text-xs sm:text-sm font-medium text-gray-700 mb-1">
                Guarantor Name
              </label>
              <input
                type="text"
                placeholder="Enter Guarantor Name"
                value={guarantorName}
                onChange={(e) => setGuarantorName(e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
            </div>
            <div className="flex flex-col">
              <label className="text-xs sm:text-sm font-medium text-gray-700 mb-1">
                Guarantor Phone Number
              </label>
              <input
                type="text"
                placeholder="Enter Guarantor Phone Number"
                value={guarantorPhone}
                onChange={(e) => setGuarantorPhone(e.target.value)}
                className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200"
              />
            </div>
          </div>

          <button
            onClick={addGuarantor}
            className="bg-[#074073] hover:bg-[#052f5a] text-white font-medium py-2.5 sm:py-2 px-6 rounded-md text-sm w-full sm:w-fit mx-auto transition-colors duration-150"
          >
            Add Guarantor
          </button>
        </div>

        {/* Added Guarantors List Section */}
        <div className="flex flex-col min-h-0 flex-1 my-2">
          <div className="bg-blue-50 p-4 rounded-md flex flex-col gap-3 overflow-y-auto max-h-[220px]">
            <h3 className="text-sm sm:text-base font-semibold text-gray-900 sticky top-0 bg-blue-50 py-1">
              Added Guarantors
            </h3>
            {manualLoanGuarantors.length > 0 ? (
              manualLoanGuarantors.map((guarantor, index) => (
                <div
                  key={guarantor.id || index}
                  className="flex justify-between items-center text-sm border-b border-blue-100 last:border-0 pb-2 last:pb-0 gap-2"
                >
                  <div className="flex flex-col min-w-0 pr-2">
                    <span className="text-gray-900 font-medium truncate">
                      {guarantor.guarantorName}
                    </span>
                    <span className="text-gray-600 text-xs truncate">
                      {guarantor.guarantorPhoneNumber}
                    </span>
                  </div>
                  <button
                    onClick={() => handleRemoveGuarantor(guarantor.id)}
                    className="text-red-500 hover:text-red-700 text-xs sm:text-sm font-medium shrink-0"
                  >
                    Remove
                  </button>
                </div>
              ))
            ) : (
              <p className="text-gray-500 text-xs sm:text-sm italic">
                Added guarantors will appear here
              </p>
            )}
          </div>
        </div>

        {/* Action Footer */}
        <div className="flex flex-col-reverse sm:flex-row justify-between border-t border-gray-200 pt-4 mt-4 gap-3 shrink-0">
          <button
            onClick={closeAddGuarantors}
            className="w-full sm:w-auto border border-[#074073] text-[#074073] hover:bg-[#f5f9ff] font-medium py-2.5 sm:py-2 px-5 rounded-md text-sm transition-colors duration-150"
          >
            Cancel Application
          </button>

          <button
            onClick={handleSubmitLoanApplication}
            className="w-full sm:w-auto bg-[#074073] hover:bg-[#052f5a] text-white font-medium py-2.5 sm:py-2 px-6 rounded-md text-sm transition-colors duration-150"
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGuarantors;
